import { useMemo } from 'react'

import { useWorkflowSchema } from 'data/hooks/workflows/workflows'

import { DEFAULT_ACTION_ICON } from './common'

type UseStepIconStateProps = {
    nodeType?: WorkflowSchemaNodeType
    node?: WorkflowActionConfig
}

export function useStepIconState({ nodeType, node }: UseStepIconStateProps) {
    const { data: schema } = useWorkflowSchema()

    const groups = schema?.groups ?? []
    const currentGroup = groups.find((group) => group.id === nodeType?.group)

    const icon = nodeType?.icon || DEFAULT_ACTION_ICON
    const iconUrl = node?.icon?.url
    const colorScheme = currentGroup?.color_scheme

    return useMemo(() => ({ icon, iconUrl, colorScheme }), [icon, iconUrl, colorScheme])
}
